import './About.css';

export default function About() {
    return (
        <div className="About">
            <div className="Content">
                <p>At Munamii Cakery, each cake, each box of cupcakes that we make has a very special value for us.</p>
                <p>We not only want to bring a dessert to your table but rather a unique experience for you, which will become an unforgettable memory.</p>
                <p>We have been in the pastry market for more than 8 years and now we offer you a new way to shop through our website.</p>
            </div>
        </div>
    )
}